<script setup lang="ts">
import type { NovaBoxBoardListNewsItemProps } from './NovaBoxBoardListNewsItem.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaBoxBoardListNewsItemProps>()

const { date } = useDateFormat()
const { gtEvent } = useGoogleTag()

const onGoNewsDetail = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '소식 목록 > 상세보기',
    eventLabel: props.source.nttSj,
    eventSlot: '',
    eventI18nAddr: '',
    eventComponent: 'Button',
  })
  useNavigations({
    url: useRoutePathIdChange(ROUTES.BOARD_NEWS_DETAIL.path, {
      id: props.source.nttGroupId,
    }),
  })
}
</script>

<template>
  <button type="button" class="list-item">
    <div class="list-header" @click="onGoNewsDetail">
      <span class="title-box">
        <em class="title">{{ source.nttSj }}</em>
        <em class="date">
          {{ date({ date: source.sysRegistDt, format: 'YYYY-MM-DD' }) }}
        </em>
      </span>
    </div>
  </button>
</template>

<style lang="scss" scoped>
.list-item {
  padding: 30px 20px;
  background-color: $color-white;
  border-radius: $radius-10;
  width: 100%;
  text-align: left;

  .list-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .title-box {
      display: flex;
      flex-direction: column;
      gap: 6px;
      width: 100%;

      em {
        display: block;
        @include text-style($text-heading3-medium);
      }

      .title {
        @include ellipsis(1);
      }

      .date {
        @include text-style($text-body-12-regular);
        line-height: 14px;
        color: $color-text-3;
      }
    }

    .icon-button {
      display: block;
      width: 20px;
      height: 20px;
      color: $color-text-3;

      @include transition(transform 0.2s);

      &.open {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
